import routes from './routes';
import type { RouteRecordRaw } from 'vue-router';
import { buildRootURL } from '@centric-os/helpers';
import { GlobalMenuGroupsRoutePathNames, GlobalMenuGroupsRouteNames } from './enums';
import { beforeEnterGuard } from './guards';

const App = () => import('./App.vue');

export * from './enums';

export const route: RouteRecordRaw = {
  path: buildRootURL(GlobalMenuGroupsRoutePathNames.GLOBAL_MENU_GROUPS),
  name: GlobalMenuGroupsRouteNames.BRANDS_ROOT,
  meta: {
    requireAuth: true,
  },
  component: App,
  children: routes,
  beforeEnter: beforeEnterGuard,
};
